<template>
	<VDialogV3
		class="files-dialog content-block-style"
		closable
    :loading="false"
		position="right"
    hide-footer

    :title="title"
	>

		<FilesList
			:entities="fileEntities"
      :max-one-file="maxOneFile"
		/>

	</VDialogV3>
</template>

<style lang="scss" src="./FilesDialog.scss"/>

<script lang="ts">

export default defineComponent({
	name: "FilesDialog",
	props: {
		title: {
			type: String,
			required: true
		},

		/** @type EntityPointer[] */
		fileEntities: {
			type:     Array,
			required: true,
		},

    /** У нас на платеже ограничение максимум 1 файл на сущность **/
    maxOneFile: {
      type: Boolean,
      default: false
    }
	}
})
</script>
